import { render } from "./ClosingSection.vue?vue&type=template&id=add16812"
import script from "./ClosingSection.vue?vue&type=script&lang=js"
export * from "./ClosingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__